import { FC } from 'react';

import { Check, Pause } from 'lucide-react';

import { StatusFilterButton } from './StatusFilterButton';
import { OfferType } from '../../../../types';

interface Props {
    onFilterChange: (status: OfferType) => void;
    activeFilter: OfferType | null;
    counts: Record<OfferType, number>;
    disabled: boolean;
}

export const QuickStatusFilters: FC<Props> = ({
    counts,
    activeFilter,
    onFilterChange,
    disabled,
}) => {
    return (
        <div className="flex flex-wrap">
            <StatusFilterButton
                icon={<Check className="h-3.5 w-3.5" />}
                label="Активні"
                count={counts.active}
                isActive={activeFilter === 'active' || activeFilter === null}
                onClick={() => onFilterChange('active')}
                color="text-green-500"
                bgColor="bg-green-500/10"
                disabled={disabled}
            />
            <StatusFilterButton
                icon={<Pause className="h-3.5 w-3.5" />}
                label="Призупинені"
                count={counts.inactive}
                isActive={activeFilter === 'inactive'}
                onClick={() => onFilterChange('inactive')}
                color="text-gray-500"
                bgColor="bg-gray-500/10"
                disabled={disabled}
            />
        </div>
    );
};
